export class Contacts {
    public id: number;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone: string;
    public visit: boolean;
    public news: boolean;
    public privacy: boolean;
    public terms: boolean;
}